<gus-version-renderer></gus-version-renderer>
@if (zoomLoading()) {
  <gus-spinner class="zoom-spinner"></gus-spinner>
}
<main>
  <div id="meetingSDKElement"></div>
</main>
<router-outlet />
